<template>
  <div class="shadow-lg py-5 px-7">
    <h4 class="text-xl font-bold mb-4">Primes vendeurs</h4>

    <div class="mb-1">
      <label for="seller_percentage_value" class="block text-sm font-medium text-gray-700 mb-2">Pourcentage</label>
      <div class="flex items-center gap-3">
        <div class="flex-1">
          <FormField
            id="seller_percentage_value"
            name="seller_percentage_value"
            trailing-add-ons="%"
            v-model="sellerPercentageValue"
          />
        </div>
        <GenericButton @click="submitEditSellerPercentage">Enregistrer</GenericButton>
      </div>
    </div>

    <div class="relative my-2">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-200"></div>
      </div>
      <div class="relative flex justify-center">
        <span class="bg-gray-50 px-3 text-xs font-semibold uppercase tracking-widest text-gray-900">ou</span>
      </div>
    </div>

    <div class="flex justify-center">
      <SecondaryButton @click="configSellerFixedPriceModalOpen = true">Configurer montant fixe</SecondaryButton>
    </div>

    <Modal size="big" :open="configSellerFixedPriceModalOpen" @close="configSellerFixedPriceModalOpen = false">
      <h4 class="text-xl font-semibold">Rétribution en montant fixe</h4>
      <p>Indiquer le montant de la rétribution par offre et par durée.</p>

      <RetributionTable
        :retributions="retributionConfigurations"
        editable
        @edit-seller-retribution="editRetributionConfiguration"
        :hideManagerRetribution="true"
        :hideSellerRetribution="false"
      />
      <div class="mt-4 flex justify-center">
        <GenericButton @click="submitEditSellerFixedPrice">Valider la rétribution</GenericButton>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Modal, FormField, GenericButton, SecondaryButton } from "@estaly/ui";
import RetributionTable from "@/components/retribution/RetributionTable.vue";
import RetributionConfigurationsService from "@/api/services/retributionConfigurations";

export default {
  name: "SellerRetributionConfiguration",

  components: {
    FormField,
    Modal,
    GenericButton,
    SecondaryButton,
    RetributionTable,
  },

  data() {
    return {
      configSellerFixedPriceModalOpen: false,
      sellerPercentageValue: null,
      retributionConfigurationsSellerFixedPriceChanges: {},
    };
  },

  computed: {
    ...mapState("store", { currentStore: "currentStore" }),
    ...mapState("retributionConfigurations", ["retributionConfigurations"]),
  },

  methods: {
    ...mapActions("store", ["fetch"]),
    ...mapActions("retributionConfigurations", ["fetchRetributionConfigurations"]),
    ...mapActions("notifications", ["notify", "clearAll"]),

    async submitEditSellerPercentage() {
      if (this.sellerPercentageValue === null || this.sellerPercentageValue === undefined)
        return document.getElementById("seller_percentage_value").focus();

      const response = await RetributionConfigurationsService.updatePercentage(this.currentStore.id, {
        sellerValue: this.sellerPercentageValue / 100,
        sellerPercentage: true,
      });
      if (!response?.success) return;

      await Promise.all([
        this.fetch({ id: this.currentStore.id }),
        this.fetchRetributionConfigurations({ perPage: 1000 }),
      ]);
      await this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
    },

    editRetributionConfiguration(retributionConfigurationId, value) {
      this.retributionConfigurationsSellerFixedPriceChanges[retributionConfigurationId] = value;
    },

    async submitEditSellerFixedPrice() {
      this.clearAll();
      const errors = [];

      await Promise.all(
        Object.entries(this.retributionConfigurationsSellerFixedPriceChanges).map(
          async ([retributionConfigurationId, value]) => {
            const response = await RetributionConfigurationsService.updateFixedPrice(
              this.currentStore.id,
              retributionConfigurationId,
              {
                sellerValue: value,
                sellerPercentage: false,
              },
            );
            if (!response?.success) errors.push(retributionConfigurationId);
            else {
              this.lowlightError(retributionConfigurationId);
              delete this.retributionConfigurationsSellerFixedPriceChanges[retributionConfigurationId];
            }
          },
        ),
      );

      await this.fetchRetributionConfigurations({ perPage: 1000 });

      if (errors.length === 0) {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Mise à jour effectuée",
        });
        this.configSellerFixedPriceModalOpen = false;
      } else {
        console.log("Errors in retribution configurations:", errors);
        errors.forEach((retributionConfigurationId) => {
          this.highlightError(retributionConfigurationId);
        });
      }
    },

    highlightError(retributionConfigurationId) {
      document
        .getElementById(`seller-retribution-${retributionConfigurationId}`)
        .classList.add("border-2", "border-red-500");
    },

    lowlightError(retributionConfigurationId) {
      document
        .getElementById(`seller-retribution-${retributionConfigurationId}`)
        .classList.remove("border-2", "border-red-500");
    },
  },

  watch: {
    currentStore: {
      immediate: true,
      handler(store) {
        this.sellerPercentageValue = store?.sellerIncentivePercentage
          ? Math.round(store.sellerIncentivePercentage * 100)
          : null;
        this.retributionConfigurationsSellerFixedPriceChanges = {};
      },
    },
  },
};
</script>
